import { render, staticRenderFns } from "./roomChangeorVacate.vue?vue&type=template&id=a4a96d20&"
import script from "./roomChangeorVacate.vue?vue&type=script&lang=js&"
export * from "./roomChangeorVacate.vue?vue&type=script&lang=js&"
import style0 from "./roomChangeorVacate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports